// tms/my-model
import {
  postData,
  postFormData,
  createFormData,
} from 'src/services/RestApi';

import { setCacheCheckin } from 'src/utils/cache-data';

export const apiCheckin = async (values) => {
  const queryData = {
    carId: values.plateField.value,
  };
  
  return await postData('api/tms/checkin', queryData);
};

export const apiCheckout = async (values) => {
  const queryData = {
    tmsId: values.tmsId,
  };
  // Rest cache, maybe throw error, user must be refresh page for reload cache
  setCacheCheckin(null);

  return await postData('api/tms/checkout', queryData);
};

export const apiUpdate = async (values) => {
  //values.tmsId = values.myId; // Add new tmsId
  const { myId, ...newPayload } = values; // Remove myId
  const { formData, queryData } = requestParams(newPayload);

  return await postFormData(
    'api/tms/edit',
    formData,
    queryData,
  );
};

export const apiRemove = async (values) => {
  return await postData(
    'api/tms/remove',
    {tmsId: values.id, status: 1},
  );
};

function requestParams(values) {
  const formData = createFormData(values);
  const isUpdate = Number(values.id) > 0;

  const queryData = {};
  queryData.tmsId = values.id;

  // Convert checkIn to seconds
  // if (values.checkinBy) {
  //   // Math.floor(new Date(values.checkIn).getTime() / 1000);
  //   queryData.checkinBy = values.checkinBy.getTime(); // Use milliseconds
  // }
  // if (values.checkoutBy) {
  //   // Math.floor(new Date(values.checkOut).getTime() / 1000);
  //   queryData.checkoutBy = values.checkoutBy.getTime(); // Use milliseconds
  // }
  if (values.plateField?.value && !isUpdate) {
      queryData.carId = values.plateField.value;
  }
  if (values.note) {
    queryData.note = values.note;
  }
  if (values.checkinKm) {
    queryData.checkinKm = values.checkinKm;
  }
  if (values.checkoutKm) {
    queryData.checkoutKm = values.checkoutKm;
  }

  return { formData, queryData };
}
